import { render, staticRenderFns } from "./MungBeanAllocateBatchList.vue?vue&type=template&id=562d12cc&scoped=true&lang=pug&"
import script from "./MungBeanAllocateBatchList.vue?vue&type=script&lang=ts&"
export * from "./MungBeanAllocateBatchList.vue?vue&type=script&lang=ts&"
import style0 from "./MungBeanAllocateBatchList.vue?vue&type=style&index=0&id=562d12cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562d12cc",
  null
  
)

export default component.exports